const pdfjs = require('pdfjs-dist/build/pdf.js');
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

module.exports = pdfjs;
